/**
 * Hazel's Theme Main JavaScript
 * Standard Shopify Ajax Cart API, Event Tracking (RedTrack & PostHog), and Navigation.
 */

(function () {
  'use strict';

  // --- Click ID & Tracking Helpers ---
  function getClickID() {
    try {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('clickid') || params.get('rtkcid') || params.get('rtkclickid');
      if (q) return q;

      var cookieNames = ['rtkclickid-store', 'rtkclickid', 'rtkcid', '_rtkcid'];
      for (var i = 0; i < cookieNames.length; i++) {
        var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + cookieNames[i] + '=([^;]*)'));
        if (m && m[1]) return decodeURIComponent(m[1]);
      }
      for (var j = 0; j < cookieNames.length; j++) {
        var ls = localStorage.getItem(cookieNames[j]);
        if (ls) return ls;
      }
      if (window.rtkClickID) return window.rtkClickID;
    } catch (e) {}
    return '';
  }

  function fireRedTrackEvent(eventType, email, firstName) {
    try {
      var clickid = getClickID();
      var tid = eventType.toLowerCase() + '_' + (clickid || Date.now());

      // 1. Client-side JS API
      var sdkFired = false;
      if (window.RedTrack && typeof window.RedTrack.track === 'function') {
        window.RedTrack.track(eventType, { email: email, first_name: firstName });
        sdkFired = true;
      } else if (window.rtk && typeof window.rtk === 'function') {
        window.rtk('track', eventType, { email: email, first_name: firstName });
        sdkFired = true;
      }

      // 2. HTTP GET Postback Beacon (fallback if JS API not loaded)
      if (!sdkFired) {
        var postbackUrl =
          'https://track.tryhazels.com/postback' +
          '?ptoken=ddhbgwzj7w' +
          '&type=' + encodeURIComponent(eventType) +
          (clickid ? '&clickid=' + encodeURIComponent(clickid) : '') +
          '&tid=' + encodeURIComponent(tid) +
          (email ? '&email=' + encodeURIComponent(email) : '') +
          (firstName ? '&first_name=' + encodeURIComponent(firstName) : '');

        console.log('RedTrack Event [' + eventType + '] URL:', postbackUrl);

        if (navigator && typeof navigator.sendBeacon === 'function') {
          navigator.sendBeacon(postbackUrl);
        } else if (typeof fetch === 'function') {
          fetch(postbackUrl, { method: 'GET', keepalive: true, mode: 'no-cors' }).catch(function () {});
        } else {
          var img = new Image();
          img.src = postbackUrl;
        }
      }
    } catch (e) {
      console.error('RedTrack event error:', e);
    }
  }

  function firePostHogEvent(eventName, properties) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(eventName, properties || {});
      }
    } catch (e) {
      console.error('PostHog event error:', e);
    }
  }

  window.fireRedTrackEvent = fireRedTrackEvent;
  window.firePostHogEvent = firePostHogEvent;
  window.getClickID = getClickID;

  // --- Currency Formatter ---
  function formatMoney(cents) {
    if (typeof cents === 'undefined' || cents === null) return '$0.00';
    var num = parseFloat(cents);
    if (isNaN(num)) return '$0.00';
    try {
      return (num / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (e) {
      return '$' + (num / 100).toFixed(2);
    }
  }

  // --- Preorder Drawer Controller ---
  var hazelsPreorder = {
    open: function (details) {
      // Close cart drawer if open
      if (hazelsCart) hazelsCart.close();

      var preorderDrawer = document.getElementById('preorder-drawer');
      var preorderOverlay = document.getElementById('preorder-drawer-overlay');
      if (!preorderDrawer) return;

      var summaryEl = document.getElementById('drawer-offer-summary');
      var titleEl = document.getElementById('drawer-offer-title');
      var detailsEl = document.getElementById('drawer-offer-details');

      if (details) {
        if (titleEl) titleEl.textContent = details.productTitle || (window.ShopifyProduct && window.ShopifyProduct.title) || "Hazel's Joint Ease+";
        if (detailsEl) {
          var detailsText = [];
          if (details.flavour) detailsText.push(details.flavour);
          if (details.bundle) detailsText.push(details.bundle);
          if (details.price) detailsText.push('$' + details.price);
          detailsEl.textContent = detailsText.join(' · ');
        }
        if (summaryEl) summaryEl.style.display = 'block';
      } else if (hazelsCart && hazelsCart.currentCart && hazelsCart.currentCart.item_count > 0) {
        var firstItem = hazelsCart.currentCart.items[0];
        if (titleEl) titleEl.textContent = firstItem.product_title || firstItem.title || "Hazel's Joint Ease+";
        if (detailsEl) {
          var lineDesc = firstItem.variant_title ? firstItem.variant_title + ' · ' : '';
          lineDesc += formatMoney(hazelsCart.currentCart.total_price);
          detailsEl.textContent = lineDesc;
        }
        if (summaryEl) summaryEl.style.display = 'block';
      }

      preorderDrawer.classList.add('open');
      if (preorderOverlay) preorderOverlay.classList.add('open');
      preorderDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      var firstInput = preorderDrawer.querySelector('input[type="text"], input[type="email"]');
      if (firstInput) setTimeout(function () { firstInput.focus(); }, 150);
    },
    close: function () {
      var preorderDrawer = document.getElementById('preorder-drawer');
      var preorderOverlay = document.getElementById('preorder-drawer-overlay');
      if (!preorderDrawer) return;

      preorderDrawer.classList.remove('open');
      if (preorderOverlay) preorderOverlay.classList.remove('open');
      preorderDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  window.hazelsPreorder = hazelsPreorder;
  window.openPreorderDrawer = hazelsPreorder.open;
  window.closePreorderDrawer = hazelsPreorder.close;
  window.hazelsStartPreorder = hazelsPreorder.open;

  // --- Shopify Ajax Cart Engine ---
  var hazelsCart = {
    currentCart: null,

    init: function () {
      this.fetchCart();
    },

    open: function () {
      var drawerEl = document.getElementById('cart-drawer');
      var overlayEl = document.getElementById('cart-overlay');
      if (drawerEl) {
        drawerEl.classList.add('open');
        drawerEl.setAttribute('aria-hidden', 'false');
      }
      if (overlayEl) overlayEl.style.display = 'block';
      document.body.style.overflow = 'hidden';

      // Always refresh cart contents upon opening
      this.fetchCart();
    },

    close: function () {
      var drawerEl = document.getElementById('cart-drawer');
      var overlayEl = document.getElementById('cart-overlay');
      if (drawerEl) {
        drawerEl.classList.remove('open');
        drawerEl.setAttribute('aria-hidden', 'true');
      }
      if (overlayEl) overlayEl.style.display = 'none';
      document.body.style.overflow = '';
    },

    updateBadges: function (count) {
      document.querySelectorAll('#cart-count-desktop, #cart-count-mobile, .cart-count').forEach(function (badge) {
        badge.textContent = count;
      });
    },

    fetchCart: function () {
      var self = this;
      return fetch('/cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart fetch error: ' + res.status);
          return res.json();
        })
        .then(function (cart) {
          self.currentCart = cart;
          self.updateBadges(cart.item_count || 0);
          self.render(cart);
          return cart;
        })
        .catch(function (err) {
          console.error('Error fetching Shopify cart:', err);
        });
    },

    add: function (variantId, quantity, metadata) {
      var self = this;
      var qty = quantity || 1;
      var meta = metadata || {};

      // Always emit standard AddToCart event
      fireRedTrackEvent('AddToCart', '', '');
      firePostHogEvent('add_to_cart', {
        variant_id: variantId || '',
        product_title: meta.productTitle || (window.ShopifyProduct && window.ShopifyProduct.title) || "Hazel's Joint Ease+",
        flavour: meta.flavour || '',
        bundle: meta.bundle || '',
        price: meta.price || 49,
        quantity: qty
      });

      window.dispatchEvent(new CustomEvent('cart:add', { detail: { variantId: variantId, metadata: meta } }));

      if (!variantId) {
        hazelsPreorder.open(meta);
        return Promise.resolve();
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: qty
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (errData) {
              console.warn('Shopify Cart Add error:', errData);
              // If product is unlisted or inventory unavailable, fallback to preorder interest drawer
              hazelsPreorder.open(meta);
              return null;
            });
          }
          return res.json();
        })
        .then(function (item) {
          // Update cart state in background and immediately open Preorder Registration Drawer
          self.fetchCart();
          hazelsPreorder.open(meta);
        })
        .catch(function (err) {
          console.warn('Cart add notice, opening preorder drawer:', err);
          hazelsPreorder.open(meta);
        });
    },

    change: function (lineKey, quantity) {
      var self = this;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          self.currentCart = cart;
          self.updateBadges(cart.item_count || 0);
          self.render(cart);
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          return cart;
        })
        .catch(function (err) {
          console.error('Error changing cart quantity:', err);
        });
    },

    render: function (cart) {
      var bodyEl = document.getElementById('cart-drawer-body');
      if (!bodyEl) return;

      if (!cart || !cart.items || cart.item_count === 0 || cart.items.length === 0) {
        bodyEl.innerHTML =
          '<div class="cart-empty" id="cart-empty-state">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
            '<p>Your cart is empty</p>' +
            '<button type="button" class="btn-primary" onclick="hazelsCart.close()">Continue Shopping</button>' +
          '</div>';
        return;
      }

      var itemsHtml = cart.items.map(function (item) {
        var prodTitle = item.product_title || item.title || 'Product';
        var varTitle = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';
        var imgSrc = item.image || (item.featured_image && item.featured_image.url) || item.featured_image || '';
        var linePrice = item.final_line_price || item.line_price || (item.price * item.quantity);

        return (
          '<div class="cart-item" data-key="' + item.key + '">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + (prodTitle.replace(/"/g, '&quot;')) + '" class="cart-item__img" width="80" height="80" loading="lazy">' : '') +
            '<div class="cart-item__details">' +
              '<p class="cart-item__name">' + prodTitle + '</p>' +
              varTitle +
              '<div class="cart-item__qty-row">' +
                '<div class="qty-control">' +
                  '<button type="button" class="qty-btn qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
                  '<span class="qty-val">' + item.quantity + '</span>' +
                  '<button type="button" class="qty-btn qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove item">' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
            '<p class="cart-item__price">' + formatMoney(linePrice) + '</p>' +
          '</div>'
        );
      }).join('');

      bodyEl.innerHTML =
        '<div class="cart-items" id="cart-items-container">' +
          itemsHtml +
        '</div>' +
        '<div class="cart-drawer__footer" id="cart-footer">' +
          '<div class="cart-subtotal">' +
            '<span>Subtotal</span>' +
            '<span id="cart-subtotal">' + formatMoney(cart.total_price) + '</span>' +
          '</div>' +
          '<button type="button" class="btn-checkout" id="cart-checkout-btn">Check out →</button>' +
          '<p class="cart-guarantee">60 DAY MONEY-BACK GUARANTEE</p>' +
        '</div>';
    }
  };

  window.hazelsCart = hazelsCart;

  // --- Initializer & Event Delegations ---
  function setupApp() {
    hazelsCart.init();

    // Header scroll shadow effect
    var header = document.getElementById('site-header');
    if (header) {
      window.addEventListener('scroll', function () {
        header.style.boxShadow = window.scrollY > 10 ? '0 2px 8px rgba(0,0,0,.08)' : '';
      });
    }

    // Mobile menu toggle
    var menuToggle = document.getElementById('mobile-menu-toggle');
    var mobileMenu = document.getElementById('mobile-menu');
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function () {
        var isOpen = mobileMenu.style.display === 'block';
        mobileMenu.style.display = isOpen ? 'none' : 'block';
        var iconMenu = menuToggle.querySelector('.icon-menu');
        var iconClose = menuToggle.querySelector('.icon-close');
        if (iconMenu) iconMenu.style.display = isOpen ? '' : 'none';
        if (iconClose) iconClose.style.display = isOpen ? 'none' : '';
      });
    }

    // Cart trigger buttons in header
    document.querySelectorAll('.cart-trigger').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        hazelsPreorder.open();
      });
    });

    // Cart close button & overlay
    var cartCloseBtn = document.getElementById('cart-close');
    var cartOverlay = document.getElementById('cart-overlay');
    if (cartCloseBtn) cartCloseBtn.addEventListener('click', function () { hazelsCart.close(); });
    if (cartOverlay) cartOverlay.addEventListener('click', function () { hazelsCart.close(); });

    // Preorder drawer close button & overlay
    var preorderCloseBtn = document.getElementById('preorder-drawer-close');
    var preorderOverlay = document.getElementById('preorder-drawer-overlay');
    if (preorderCloseBtn) preorderCloseBtn.addEventListener('click', function () { hazelsPreorder.close(); });
    if (preorderOverlay) preorderOverlay.addEventListener('click', function () { hazelsPreorder.close(); });

    // Escape key listener
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hazelsCart.close();
        hazelsPreorder.close();
      }
    });

    // Global Click Delegation for Dynamic Cart Drawer Elements
    document.addEventListener('click', function (e) {
      // 1. Checkout button in cart drawer -> opens preorder / lead capture drawer
      var checkoutBtn = e.target.closest('#cart-checkout-btn, .btn-checkout');
      if (checkoutBtn && checkoutBtn.closest('#cart-drawer')) {
        e.preventDefault();
        hazelsPreorder.open();
        return;
      }

      // 2. Quantity control buttons (+ / -)
      var qtyBtn = e.target.closest('.qty-btn');
      if (qtyBtn && qtyBtn.dataset.key) {
        e.preventDefault();
        var key = qtyBtn.dataset.key;
        var qty = parseInt(qtyBtn.dataset.qty, 10);
        hazelsCart.change(key, Math.max(0, qty));
        return;
      }

      // 3. Item remove button
      var removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn && removeBtn.dataset.key) {
        e.preventDefault();
        var itemKey = removeBtn.dataset.key;
        hazelsCart.change(itemKey, 0);
        return;
      }
    });
  }

  // Handle immediate execution if DOM is already ready (handles deferred script loading)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupApp);
  } else {
    setupApp();
  }
})();